<template>
  <div>
    <vx-card style="margin-bottom: 20px">
      <b-row align-v="center">
        <b-col lg="1" sm="12" align-self="center">
          <label for="datepicker-sm">Tarih: </label></b-col
        >

        <b-col lg="3" sm="5" align-self="center">
          <b-form-datepicker
            bottom
            v-model="datepickerbaslangic"
            size="md"
            local="en"
            today-variant="danger"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }"
          />
        </b-col>

        <b-col
          lg="2"
          sm="5"
          style="text-align-last: center"
          align-self="center"
        >
          <vs-button
            v-on:click="listele()"
            line-origin="left"
            color="primary"
            type="gradient"
            style=" border-radius: 5px"
            >Listele</vs-button
          >
        </b-col>
        <b-col
          lg="2"
          sm="5"
          style="text-align-last: center"
          align-self="center"
        >
          <vs-button
            v-on:click="tahsilat()"
            line-origin="left"
            color="success"
            type="gradient"
            style=" border-radius: 5px"
            >Yazdır</vs-button
          ></b-col
        >

        <b-col
          lg="2"
          sm="5"
          style="text-align-last: center"
          align-self="center"
        >
          <vs-button
            v-on:click="onBtExport()"
            style="
                        margin: 5px 0px;
                        font-weight: bold;
                        border-radius: 5px;
                        width: 100%;
                      "
          >
            Excel indir
          </vs-button></b-col
        >
      </b-row>
    </vx-card>

    <b-row>
      <b-col :key="index" v-for="(val, index) in kasaListData" lg="6" sm="12">
        <vs-card>
          <div slot="header">
            <h3>
              {{ val.CASHNAME }}
            </h3>
          </div>
          <div>
            <!--
            <vs-table :data="val.data">
              <template slot="thead">
                <vs-th sort-key="DESCRIPTION">DESCRIPTION</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].DESCRIPTION">
                    {{ data[indextr].DESCRIPTION }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>-->

            <ag-grid-vue
              style="width: 100%; height: 450px"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="val.data"
              :localeText="localeText"
              :pagination="true"
              @grid-ready="onGridReady($event, index)"
              @first-data-rendered="onFirstDataRendered"
            >
            </ag-grid-vue>
          </div>
        </vs-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      leftApi: null,
      rightApi: null,
      leftApi1: null,
      rightApi1: null,

      leftRowData: null,
      rightRowData: null,
      leftRowData1: null,
      rightRowData1: null,
      weekday: 1,
      kasalenght: 0,
      rowData: null,
      localeText: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      datepickerbaslangic: "",
      cariHareketlerListesi: [],
      kasalist: [],
      kasaListData: []
    };
  },
  computed: {
    /*   getdetayHareket() {
      console.log(this.rowData);
      return this.rowData;
    },*/
  },
  methods: {
    onBtExport() {
      //   this.gridApi.exportDataAsExcel();
      var spreadsheets = [];
      /*
      spreadsheets.push(
        this.leftApi.getSheetDataForExcel({ sheetName: "Athletes" }),
        this.rightApi.getSheetDataForExcel({ sheetName: "Selected Athletes" }),
        this.leftApi1.getSheetDataForExcel({ sheetName: "Athletes" }),
        this.rightApi1.getSheetDataForExcel({ sheetName: "Selected Athletes" })
      );

      exportMultipleSheetsAsExcel({
        data: spreadsheets,
        fileName: "ag-grid.xlsx"
      });*/
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params, side) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      if (side === 0) {
        this.leftApi = params.api;
        this.leftColumnApi = params.columnApi;
      }
      if (side === 1) {
        this.rightApi = params.api;
        //  this.addGridDropZone();
      }
      if (side === 2) {
        this.leftApi1 = params.api;
        this.leftColumnApi = params.columnApi;
      }

      if (side === 3) {
        this.rightApi2 = params.api;
        //   this.addGridDropZone();
      }
      //  this.rpAcikFaturalarDetay();
    },
    getKasaHareketList(index) {
      try {
        var vm = this;

        var vs = this.$vs;
        var resp = [];

        var seczam = moment(String(vm.datepickerbaslangic)).format(
          "DD.MM.YYYY"
        );
        if (seczam == "Invalid date") {
          var today = new Date();
          seczam = moment(String(today)).format("DD.MM.YYYY");
        }
        if (index - 1 == -1) {
          vm.loadGrids();
        } else {
          const soap = require("soap");
          const url = state.sistemAddress;
          const args = {
            token: Store.state.tokenId,
            CASHID: vm.kasalist[index - 1].CASHID,
            TARIH2: seczam
          };
          console.log(args);
          soap.createClient(url, function(err, client) {
            client.INT_Kasa_Hareket(args, function(err, result) {
              if (result.INT_Kasa_HareketResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }

              try {
                if (vm.veriler.response == "Ok") {
                  vm.veriler = JSON.parse(result.INT_Kasa_HareketResult);
                  var list = JSON.parse(vm.veriler.jsonData);
                  //  resolve(list);
                  vm.kasaListData.push({
                    CASHNAME: vm.kasalist[index - 1].CASHNAME,
                    data: list
                  });

                  index--;
                  vm.getKasaHareketList(index);
                } else {
                }
              } catch (error) {
                console.log(result);
                console.log(error);
              }
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    loadGrids() {
      console.log(this.kasaListData);
      this.kasaListData.forEach((val, index) => {
        if (index == 0) {
          this.leftRowData = val.data;
        } else if (index == 1) {
          this.rightRowData = val.data;
        } else if (index == 2) {
          this.leftRowData1 = val.data;
        } else if (index == 3) {
          this.rightRowData1 = val.data;
        }
      });
      /* 
      this.leftRowData = [...this.rawData.slice(0, this.rawData.length / 2)];
      this.rightRowData = [...this.rawData.slice(this.rawData.length / 2)];*/
    },
    getKasaList() {
      var vm = this;
      var vs = this.$vs;
      vm.kasaListData = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.INT_Kasa_Ls(args, function(err, result) {
          if (result.INT_Kasa_LsResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Kasa_LsResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              vm.kasalist = list;
              vm.kasalenght = list.length;
              vm.getKasaHareketList(vm.kasalenght);
            } else {
            }
          } catch (error) {}
        });
      });
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    }
  },
  created() {
    this.getKasaList();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Açıklama",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "DESCRIPTION"
      },
      {
        headerName: "Giriş",
        field: "GIRIS",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Çıkış",
        field: "CIKIS",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Bakiye",
        field: "BAKIYE",
        sortable: true,
        filter: "agDateColumnFilter",
        cellClass: "rag-amber",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.BAKIYE, "₺"),
        type: "rightAligned"
      }
    ];
  }
};
</script>
